import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('Verifying your email address...');
  const [verifiedEmail, setVerifiedEmail] = useState<string>('');

  useEffect(() => {
    const token = searchParams.get('token');
    const orgId = searchParams.get('org');   // present only if coming from team invite
    const role = searchParams.get('role');   // role assigned by admin

    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    const verify = async () => {
      try {
        // ── Delegate ALL DB work to the edge function which uses service role ──
        // This bypasses RLS entirely - no session needed for unauthenticated users
        const { data, error } = await supabase.functions.invoke('verify-email', {
          body: { token, orgId: orgId || null, role: role || null },
        });

        if (error) {
          console.error('Edge function error:', error);
          setStatus('error');
          setMessage('Verification failed. Please try again or request a new link.');
          return;
        }

        if (!data?.success) {
          setStatus('error');
          setMessage(data?.error || 'Verification failed.');
          return;
        }

        const email = data.email || '';
        setVerifiedEmail(email);

        setStatus('success');
        setMessage(
          orgId
            ? "Your email has been verified and you've joined the team! You can now sign in."
            : 'Your email has been verified! You can now sign in.'
        );

        // Attempt session refresh for auto-redirect if already logged in
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          const { error: refreshError } = await supabase.auth.refreshSession();
          if (!refreshError) {
            toast({
              title: "Success",
              description: orgId
                ? "Email verified. You've joined the team! Redirecting..."
                : "Email verified. Redirecting to dashboard...",
              className: "bg-green-50 border-green-200"
            });
            setTimeout(() => navigate('/'), 2000);
            return;
          }
        }

      } catch (err) {
        console.error('Verification error:', err);
        setStatus('error');
        setMessage('An unexpected error occurred.');
      }
    };

    verify();
  }, [searchParams, navigate, toast]);

  const handleContinue = () => {
    navigate(`/auth?email=${encodeURIComponent(verifiedEmail)}&verified=true`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardContent className="pt-8 pb-8 text-center space-y-6">

          {/* Logo */}
          <div className="flex justify-center mb-4">
            <div className="bg-green-600 p-3 rounded-full">
              <img src="/greencard-uploads/logo.png" alt="Logo" className="h-8 w-8 bg-white rounded-full object-contain" />
            </div>
          </div>

          {/* Status Icon */}
          <div className="flex justify-center">
            {status === 'verifying' && (
              <Loader2 className="h-16 w-16 text-green-600 animate-spin" />
            )}
            {status === 'success' && (
              <CheckCircle2 className="h-16 w-16 text-green-600 animate-in zoom-in duration-300" />
            )}
            {status === 'error' && (
              <XCircle className="h-16 w-16 text-red-500 animate-in zoom-in duration-300" />
            )}
          </div>

          {/* Message */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {status === 'verifying' && 'Verifying Email...'}
              {status === 'success' && 'Email Verified!'}
              {status === 'error' && 'Verification Failed'}
            </h2>
            <p className="text-gray-600">{message}</p>
          </div>

          {/* Action Button */}
          {status !== 'verifying' && (
            <div className="pt-4">
              <Button
                onClick={handleContinue}
                className={`w-full ${status === 'success' ? 'bg-green-600 hover:bg-green-700' : ''}`}
              >
                {status === 'success' ? 'Continue to Login' : 'Back to Login'}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          )}

        </CardContent>
      </Card>
    </div>
  );
};







// import React, { useEffect, useState } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { Card, CardContent } from '@/components/ui/card';
// import { Button } from '@/components/ui/button';
// import { Loader2, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
// import { supabase } from '@/integrations/supabase/client';
// import { useToast } from '@/hooks/use-toast';

// export const VerifyEmailPage = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const { toast } = useToast();
  
//   const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
//   const [message, setMessage] = useState('Verifying your email address...');
//   const [verifiedEmail, setVerifiedEmail] = useState<string>('');

//   useEffect(() => {
//     const token = searchParams.get('token');
//     const orgId = searchParams.get('org'); // present only if coming from team invite

//     if (!token) {
//       setStatus('error');
//       setMessage('Invalid verification link.');
//       return;
//     }

//     const verify = async () => {
//       try {
//         // ── Delegate ALL DB work to the edge function which uses service role ──
//         // This bypasses RLS entirely - no session needed for unauthenticated users
//         const { data, error } = await supabase.functions.invoke('verify-email', {
//           body: { token, orgId: orgId || null },
//         });

//         if (error) {
//           console.error('Edge function error:', error);
//           setStatus('error');
//           setMessage('Verification failed. Please try again or request a new link.');
//           return;
//         }

//         if (!data?.success) {
//           setStatus('error');
//           setMessage(data?.error || 'Verification failed.');
//           return;
//         }

//         const email = data.email || '';
//         setVerifiedEmail(email);

//         setStatus('success');
//         setMessage(
//           orgId
//             ? "Your email has been verified and you've joined the team! You can now sign in."
//             : 'Your email has been verified! You can now sign in.'
//         );

//         // Attempt session refresh for auto-redirect if already logged in
//         const { data: { session } } = await supabase.auth.getSession();
//         if (session) {
//           const { error: refreshError } = await supabase.auth.refreshSession();
//           if (!refreshError) {
//             toast({
//               title: "Success",
//               description: orgId
//                 ? "Email verified. You've joined the team! Redirecting..."
//                 : "Email verified. Redirecting to dashboard...",
//               className: "bg-green-50 border-green-200"
//             });
//             setTimeout(() => navigate('/'), 2000);
//             return;
//           }
//         }

//       } catch (err) {
//         console.error('Verification error:', err);
//         setStatus('error');
//         setMessage('An unexpected error occurred.');
//       }
//     };

//     verify();
//   }, [searchParams, navigate, toast]);

//   const handleContinue = () => {
//     navigate(`/auth?email=${encodeURIComponent(verifiedEmail)}&verified=true`);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
//       <Card className="w-full max-w-md shadow-lg">
//         <CardContent className="pt-8 pb-8 text-center space-y-6">

//           {/* Logo */}
//           <div className="flex justify-center mb-4">
//             <div className="bg-green-600 p-3 rounded-full">
//               <img src="/greencard-uploads/logo.png" alt="Logo" className="h-8 w-8 bg-white rounded-full object-contain" />
//             </div>
//           </div>

//           {/* Status Icon */}
//           <div className="flex justify-center">
//             {status === 'verifying' && (
//               <Loader2 className="h-16 w-16 text-green-600 animate-spin" />
//             )}
//             {status === 'success' && (
//               <CheckCircle2 className="h-16 w-16 text-green-600 animate-in zoom-in duration-300" />
//             )}
//             {status === 'error' && (
//               <XCircle className="h-16 w-16 text-red-500 animate-in zoom-in duration-300" />
//             )}
//           </div>

//           {/* Message */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-900 mb-2">
//               {status === 'verifying' && 'Verifying Email...'}
//               {status === 'success' && 'Email Verified!'}
//               {status === 'error' && 'Verification Failed'}
//             </h2>
//             <p className="text-gray-600">{message}</p>
//           </div>

//           {/* Action Button */}
//           {status !== 'verifying' && (
//             <div className="pt-4">
//               <Button
//                 onClick={handleContinue}
//                 className={`w-full ${status === 'success' ? 'bg-green-600 hover:bg-green-700' : ''}`}
//               >
//                 {status === 'success' ? 'Continue to Login' : 'Back to Login'}
//                 <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             </div>
//           )}

//         </CardContent>
//       </Card>
//     </div>
//   );
// };







// import React, { useEffect, useState } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { Card, CardContent } from '@/components/ui/card';
// import { Button } from '@/components/ui/button';
// import { Loader2, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
// import { TokenService } from '@/services/tokenService';
// import { supabase } from '@/integrations/supabase/client';
// import { useToast } from '@/hooks/use-toast';

// export const VerifyEmailPage = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const { toast } = useToast();
  
//   const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
//   const [message, setMessage] = useState('Verifying your email address...');
//   const [verifiedEmail, setVerifiedEmail] = useState<string>('');

//   useEffect(() => {
//     const token = searchParams.get('token');
//     const orgId = searchParams.get('org'); // present only if coming from team invite

//     if (!token) {
//       setStatus('error');
//       setMessage('Invalid verification link.');
//       return;
//     }

//     const verify = async () => {
//       try {
//         // 1. Verify token and update auth.users via RPC
//         const result = await TokenService.verifyUserEmail(token);

//         if (!result.success) {
//           setStatus('error');
//           setMessage(result.error || 'Verification failed');
//           return;
//         }

//         const email = result.email || '';
//         setVerifiedEmail(email);

//         // 2. If this came from a team invite, activate the membership
//         if (orgId && email) {
//           await activateTeamMembership(email, orgId);
//         }

//         setStatus('success');
//         setMessage(
//           orgId
//             ? "Your email has been verified and you've joined the team! You can now sign in."
//             : 'Your email has been verified! You can now sign in.'
//         );

//         // 3. Attempt session refresh and auto-redirect
//         const { data: { session } } = await supabase.auth.getSession();

//         if (session) {
//           const { error: refreshError } = await supabase.auth.refreshSession();
//           if (!refreshError) {
//             toast({
//               title: "Success",
//               description: orgId
//                 ? "Email verified. You've joined the team! Redirecting..."
//                 : "Email verified. Redirecting to dashboard...",
//               className: "bg-green-50 border-green-200"
//             });
//             setTimeout(() => navigate('/'), 2000);
//             return;
//           }
//         }

//       } catch (err) {
//         setStatus('error');
//         setMessage('An unexpected error occurred.');
//       }
//     };

//     verify();
//   }, [searchParams, navigate, toast]);

//   // ─── ACTIVATE TEAM MEMBERSHIP ───────────────────────────────────────────────
//   const activateTeamMembership = async (email: string, orgId: string) => {
//     try {
//       // Find the user's profile ID
//       const { data: profile, error: profileError } = await supabase
//         .from('user_profiles')
//         .select('id')
//         .eq('email', email.toLowerCase())
//         .single();

//       if (profileError || !profile) {
//         console.error('Could not find profile for membership activation:', profileError);
//         return; // Non-fatal - email is still verified
//       }

//       // Update team_members row: pending → active, set joined_at, link user_id
//       const { error: memberError } = await supabase
//         .from('team_members')
//         .update({
//           status: 'active',
//           user_id: profile.id,
//           joined_at: new Date().toISOString(),
//           updated_at: new Date().toISOString()
//         })
//         .eq('email', email.toLowerCase())
//         .eq('organization_id', orgId)
//         .eq('status', 'pending'); // safety: only update if still pending

//       if (memberError) {
//         console.error('Error activating team membership:', memberError);
//         // Non-fatal - user is verified, admin can see them in the team list
//       } else {
//         console.log('✅ Team membership activated for:', email);
//       }
//     } catch (error) {
//       console.error('Error in activateTeamMembership:', error);
//     }
//   };

//   // ─── NAVIGATION ──────────────────────────────────────────────────────────────
//   const handleContinue = () => {
//     navigate(`/auth?email=${encodeURIComponent(verifiedEmail)}&verified=true`);
//   };

//   // ─── RENDER ──────────────────────────────────────────────────────────────────

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
//       <Card className="w-full max-w-md shadow-lg">
//         <CardContent className="pt-8 pb-8 text-center space-y-6">

//           {/* Logo */}
//           <div className="flex justify-center mb-4">
//             <div className="bg-green-600 p-3 rounded-full">
//               <img src="/greencard-uploads/logo.png" alt="Logo" className="h-8 w-8 bg-white rounded-full object-contain" />
//             </div>
//           </div>

//           {/* Status Icon */}
//           <div className="flex justify-center">
//             {status === 'verifying' && (
//               <Loader2 className="h-16 w-16 text-green-600 animate-spin" />
//             )}
//             {status === 'success' && (
//               <CheckCircle2 className="h-16 w-16 text-green-600 animate-in zoom-in duration-300" />
//             )}
//             {status === 'error' && (
//               <XCircle className="h-16 w-16 text-red-500 animate-in zoom-in duration-300" />
//             )}
//           </div>

//           {/* Message */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-900 mb-2">
//               {status === 'verifying' && 'Verifying Email...'}
//               {status === 'success' && 'Email Verified!'}
//               {status === 'error' && 'Verification Failed'}
//             </h2>
//             <p className="text-gray-600">{message}</p>
//           </div>

//           {/* Action Button */}
//           {status !== 'verifying' && (
//             <div className="pt-4">
//               <Button
//                 onClick={handleContinue}
//                 className={`w-full ${status === 'success' ? 'bg-green-600 hover:bg-green-700' : ''}`}
//               >
//                 {status === 'success' ? 'Continue to Login' : 'Back to Login'}
//                 <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             </div>
//           )}

//         </CardContent>
//       </Card>
//     </div>
//   );
// };






// import React, { useEffect, useState } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { Card, CardContent } from '@/components/ui/card';
// import { Button } from '@/components/ui/button';
// import { Loader2, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
// import { TokenService } from '@/services/tokenService';
// import { supabase } from '@/integrations/supabase/client';
// import { useToast } from '@/hooks/use-toast';

// export const VerifyEmailPage = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const { toast } = useToast();
  
//   const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
//   const [message, setMessage] = useState('Verifying your email address...');
//   const [verifiedEmail, setVerifiedEmail] = useState<string>('');

//   useEffect(() => {
//     const token = searchParams.get('token');

//     if (!token) {
//       setStatus('error');
//       setMessage('Invalid verification link.');
//       return;
//     }

//     const verify = async () => {
//       try {
//         // 1. Verify Token and Update DB
//         const result = await TokenService.verifyUserEmail(token);

//         if (!result.success) {
//           setStatus('error');
//           setMessage(result.error || 'Verification failed');
//           return;
//         }

//         setVerifiedEmail(result.email || '');
//         setStatus('success');
//         setMessage('Account verified successfully!');

//         // 2. Attempt Auto-Login / Session Refresh
//         const { data: { session } } = await supabase.auth.getSession();

//         if (session) {
//           const { error: refreshError } = await supabase.auth.refreshSession();
          
//           if (!refreshError) {
//              toast({
//               title: "Success",
//               description: "Email verified. Redirecting to dashboard...",
//               className: "bg-green-50 border-green-200"
//             });
//             // Redirect to dashboard after short delay
//             setTimeout(() => navigate('/'), 2000);
//             return;
//           }
//         }
        
//       } catch (err) {
//         setStatus('error');
//         setMessage('An unexpected error occurred.');
//       }
//     };

//     verify();
//   }, [searchParams, navigate, toast]);

//   const handleContinue = () => {
//     // Redirect to login, pre-filling the email if we have it
//     navigate(`/auth?email=${encodeURIComponent(verifiedEmail)}&verified=true`);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
//       <Card className="w-full max-w-md shadow-lg">
//         <CardContent className="pt-8 pb-8 text-center space-y-6">
          
//           {/* Logo Section */}
//           <div className="flex justify-center mb-4">
//             <div className="bg-green-600 p-3 rounded-full">
//                {/* Use your logo component or img tag here */}
//                <img src="/greencard-uploads/logo.png" alt="Logo" className="h-8 w-8 bg-white rounded-full object-contain" />
//             </div>
//           </div>

//           {/* Status Icons */}
//           <div className="flex justify-center">
//             {status === 'verifying' && (
//               <Loader2 className="h-16 w-16 text-green-600 animate-spin" />
//             )}
//             {status === 'success' && (
//               <CheckCircle2 className="h-16 w-16 text-green-600 animate-in zoom-in duration-300" />
//             )}
//             {status === 'error' && (
//               <XCircle className="h-16 w-16 text-red-500 animate-in zoom-in duration-300" />
//             )}
//           </div>

//           {/* Headings */}
//           <div>
//             <h2 className="text-2xl font-bold text-gray-900 mb-2">
//               {status === 'verifying' && 'Verifying Email...'}
//               {status === 'success' && 'Email Verified!'}
//               {status === 'error' && 'Verification Failed'}
//             </h2>
//             <p className="text-gray-600">
//               {message}
//             </p>
//           </div>

//           {/* Actions */}
//           {status !== 'verifying' && (
//             <div className="pt-4">
//               <Button 
//                 onClick={handleContinue}
//                 className={`w-full ${status === 'success' ? 'bg-green-600 hover:bg-green-700' : ''}`}
//               >
//                 {status === 'success' ? 'Continue to Login' : 'Back to Login'}
//                 <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             </div>
//           )}

//         </CardContent>
//       </Card>
//     </div>
//   );
// };